import ModuleTitle from "../../dashboard/ModuleTitle";
import TaskItem from "../../dashboard/TaskItem";
import { IAssignedModule, IAssignedTask } from "../../../types/generalTypes";
import { Minus, Plus } from "@phosphor-icons/react";
import { useQuery } from "@tanstack/react-query";
import { adminGetModuleContentByMcId } from "../queries";

export default function AssignedModules({
  modules,
  openedModule,
  setOpenedModule,
  setShouldFetch
}: {
  modules: IAssignedModule[];
  openedModule: undefined | IAssignedModule;
  setOpenedModule: (s: undefined | IAssignedModule) => void;
  setShouldFetch: (a: boolean) => void;
}) {
  const { data: moduleContents, isSuccess } = useQuery(
    adminGetModuleContentByMcId({
      mcId: openedModule?.module_cohort_id,
    })
  );

  return (
    <div className="p-8 border-t border-white/20">
      <h1 className="text-2xl mb-4">Önceden atanmış Modüller</h1>
      <div className="flex flex-col">
        {modules.map((cc) => (
          <div key={cc.module_id} className="">
            <div className="flex items-center gap-2">
              <div
                className="p-2.5 bg-white/10 hover:bg-white/20 rounded cursor-pointer"
                onClick={() =>
                  setOpenedModule(
                    openedModule?.module_id === cc.module_id ? undefined : cc
                  )
                }
              >
                {openedModule?.module_id === cc.module_id ? (
                  <Minus size={24} />
                ) : (
                  <Plus size={24} />
                )}
              </div>
              <div className="flex-1">
                <ModuleTitle cc={cc} showCompletion={false} />
              </div>
            </div>
            {openedModule &&
              openedModule.module_id === cc.module_id &&
              (isSuccess ? (
                <div className="border-white/20 hover:border-white/25 text-white mb-4 last:mb-0 border rounded-xl transition-colors p-2">
                  {moduleContents.length > 0 ? (
                    moduleContents[0].contents.map((task: IAssignedTask) => (
                      <div className="flex items-center gap-1">
                        <TaskItem
                          key={task.tag + task.id}
                          item={task}
                          showCompletion={false}
                        />
                        <span className="text-sm text-white/70 pt-0.5">(id: {task.id})</span>
                      </div>
                    ))
                  ) : (
                    <div className="bg-white/10 p-4 text-center rounded-lg">
                      İçerik eklenmemiş
                    </div>
                  )}
                  <button
                    className="bg-myBlue h-10 mt-2 text-sm w-full rounded-lg cursor-pointer font-bold"
                    onClick={() => setShouldFetch(true)}
                  >
                    İÇERİK ATA
                  </button>
                </div>
              ) : (
                <div className="bg-white/10 p-4 text-center rounded-lg">
                  Yükleniyor
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}
